import React, {useContext} from "react";
import {motion} from "framer-motion";
import "./Publication.scss";
import {publicationSection} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import {fadeUp, vp} from "../../utils/animations";

export default function Publication() {
  const {isDark} = useContext(StyleContext);
  if (!publicationSection.display) return null;

  const {entry} = publicationSection;

  return (
    <motion.section
      className={`pub ${isDark ? "dark" : ""}`}
      id="publication"
      initial="hidden"
      whileInView="show"
      viewport={vp}
      variants={fadeUp}
    >
      <div className="pub__inner">
        <motion.div className="pub__header" variants={fadeUp}>
          <span className="section-label">Publication</span>
          <h2 className="pub__title">{publicationSection.title}</h2>
          <p className="pub__tagline">{publicationSection.tagline}</p>
        </motion.div>

        <motion.article
          className="pub__card"
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{once: true, amount: 0.15}}
        >
          {entry.award && <div className="pub__badge">{entry.award}</div>}

          <h3 className="pub__paper-title">{entry.title}</h3>
          <p className="pub__authors">{entry.authors}</p>
          <p className="pub__venue">
            {entry.venue} · {entry.publisher}
          </p>

          <p className="pub__summary">{entry.summary}</p>

          <div className="pub__footer">
            <div className="pub__tech">
              {entry.tech.map((t, i) => (
                <span key={i} className="tech-tag">
                  {t}
                </span>
              ))}
            </div>
            {entry.link && (
              <a
                href={entry.link}
                target="_blank"
                rel="noopener noreferrer"
                className="pub__link"
              >
                {entry.linkLabel || "Read Paper"} ↗
              </a>
            )}
          </div>
        </motion.article>
      </div>
    </motion.section>
  );
}
